module.exports = __webpack_public_path__ + "img/bg.36aa3c06.png";